import React, { useEffect, useRef } from 'react'
import ReactRotatingText from 'react-rotating-text'
import { useSpring, animated } from 'react-spring'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const HomeSection = ({ onSectionChange, currentSection }) => {
  const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }))

  const homeSectionRef = useRef()
  const { t } = useTranslation()

  const handleScroll = () => {
    const scrollTop = homeSectionRef.current.getBoundingClientRect().bottom
    if (scrollTop <= 100 && currentSection === 'section1') {
      onSectionChange('section2')
    } else if (scrollTop > 100 && currentSection === 'section2') {
      onSectionChange('section1')
    }
  }

  const nextSection = (event, section) => {
    event.preventDefault()
    document
      .getElementById(section)
      .scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
  const trans1 = (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`
  const trans2 = (x, y) => `translate3d(${x / 8 + 35}px,${y / 8 - 230}px,0)`
  const trans3 = (x, y) => `translate3d(${x / 6 - 250}px,${y / 6 - 200}px,0)`
  const trans4 = (x, y) => `translate3d(${x / 3.5}px,${y / 3.5}px,0)`

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  return <section ref={homeSectionRef}
  onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })}
    id="section1"
    className="h-screen min-h-screen md:pl-20 px-8 relative bg-martinique w-full text-center"
  >
    <div className="absolute top-0 bottom-0 left-0 right-0 overflow-hidden z-0">

      <animated.svg style={{ transform: props.xy.interpolate(trans1), left: '30%', top: '15%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#ff4c60"/>
        </g>
      </animated.svg>

       <animated.svg style={{ transform: props.xy.interpolate(trans4), right: '30%', bottom: '10%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#ff4c60"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans1), right: '50%', bottom: '50%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#ff4c60"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans2), right: '15%', bottom: '30%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#44d7b6"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans3), left: '24%', top: '38%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#ffd15c"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans4), left: '34%', top: '59%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#6c6ce5"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans1), right: '34%', top: '59%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#ffd15c"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans3), right: '30%', top: '30%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#6c6ce5"/>
        </g>
      </animated.svg>

      <animated.svg style={{ transform: props.xy.interpolate(trans4), bottom: '30%', left: '10%' }} className="w-5 h-5 absolute" xmlns="http://www.w3.org/2000/svg">
        <g>
          <ellipse ry="10" rx="10" cx="10" cy="10" strokeWidth="1.5" fill="#44d7b6"/>
        </g>
      </animated.svg>

    </div>

    <div className="flex flex-col space-y-5 md:space-y-10 pt-24">
    <h1 className="font-bold text-4xl text-white mt-6 relative z-10 hidden">Alexandre Lion</h1>
    <div className="text-white text-left text-3xl md:text-4.5xl lg:text-5xl leading-loose relative z-10 ">{t('homeSection.ihelp')} <span className="font-bold border-b-4 border-radical-red"><ReactRotatingText eraseMode="overwrite" typingInterval={10} pause={2000} items={[t('homeSection.clients.startups'), t('homeSection.clients.smb'), t('homeSection.clients.agencies')]} /></span></div>
    <div className="text-white text-left text-3xl md:text-4.5xl lg:text-5xl leading-loose relative z-10">{t('homeSection.toword')} <span className="font-bold border-b-4 border-energy-yellow">{t('homeSection.value')}</span></div>
    <div className="text-white text-left text-3xl md:text-4.5xl lg:text-5xl leading-loose relative z-10">{t('homeSection.whatword')} <span className="font-bold border-b-4 border-turquoise"><ReactRotatingText eraseMode="overwrite" typingInterval={10} emptyPause={800} items={[t('homeSection.what.first'), t('homeSection.what.second'), t('homeSection.what.third')]} /></span></div>
    </div>

    <div className="absolute bottom-5 left-0 w-full z-10">
      <a
      onClick={(e) => nextSection(e, 'section2')}
      className="cursor-pointer"
      >
        <div className="inline-block mb-12 bg-radical-red mt-12 px-5 py-4 font-bold text-white rounded-full transition duration-500 ease-in-out hover:bg-radical-red-400 transform hover:scale-110 relative z-10">
          {t('homeSection.cta')} ✨
        </div>
      </a>
      <a
        onClick={(e) => nextSection(e, 'section2')}
        className="m-auto block text-center cursor-pointer"
        style={{ maxWidth: '100px' }}
      >
        <span className="text-sm text-white">{t('homeSection.scrollDown')}</span>
        <br />
        <span className="border-2 border-white rounded-xl w-5 h-7 block mx-auto mt-3">
          <span className="animate-bounce border-2 border-white rounded-xl w-1 h-1 block mx-auto mt-3"></span>
        </span>
      </a>
    </div>
  </section>
}

export default HomeSection
